import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { Col, Row, Table } from "react-bootstrap";
import { Form } from "react-bootstrap";
import BasicPagination from "../../../Pagination/Pagination";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { SuperAdminTopTextSearchIcon } from "../../superAdminReusable/reusableTable/SuperAdminTopTextSearchIcon";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import ChainsListVendorActive from "./ChainsListVendorActive";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import SelectFilter from "../../../reusableComponents/selectFilter";

import PropTypes from "prop-types";

import { connect } from "react-redux";
import Alert from "react-s-alert";
import {
  admin_get_active_chains_vendor,
  admin_change_active_chains_vendor,
} from "../../../../store/actions/SuperAdminActions/adminChainsManagement";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import isEmpty from "../../../../store/validation/is-Empty";
import authReducers from "../../../../store/reducers/authReducers";

const SuperAdminActiveChainsVendor = (props) => {
  const [showFilter, seShowFilter] = useState(false);
  const [page, setPage] = useState(1);
  const [screen, setScreen] = useState(false);
  const dispatch = useDispatch();
  // const [activeChains, setActiveChains] = useState([]);
  const [dateQuery, setDateQuery] = useState({});
  const [search, setSearch] = useState("");

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  };

  const handleShowFilter = () => {
    seShowFilter({
      showFilter: !showFilter.showFilter,
    });
  };

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  const activeChains = useSelector((state) => {
    return !isEmpty(state?.superAdminChainVendors?.activeChainVendors)
      ? state.superAdminChainVendors?.activeChainVendors
      : [];
  });

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      const token = auth.accessToken;
      dispatch(
        admin_get_active_chains_vendor(
          token,
          "APPROVED",
          dateQuery.startDate,
          dateQuery.endDate
        )
      );
    }
  }, [dateQuery]);

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    setPage(pageNo);
  };

  const updateStatus = (restaurant_id, status) => {
    const token = auth.accessToken;
    dispatch(
      admin_change_active_chains_vendor(
        token,
        restaurant_id,
        {
          status: status ? "APPROVED" : "NOTAPPROVED",
        },
        onSuccess
      )
    );
  };

  const onSuccess = () => {
    const token = auth.accessToken;
    dispatch(
      admin_get_active_chains_vendor(
        token,
        "APPROVED",
        dateQuery.startDate,
        dateQuery.endDate
      )
    );
    Alert.success(`<h4>Successfully updated status</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };
  return auth.loader ? (
    <AmealioLoader />
  ) : (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row superadmin-pending-chains-vendor">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Active Chain Vendor Requests
                </div>
                <NavLink
                  to="/superadmin-add-chains-vendor"
                  className="btn btn-danger btn2 btn-lg"
                >
                  + Add New Chain
                </NavLink>
              </div>
              <div className="d-flex justify-content-end mt-3 mb-3">
                <RightSideCountTop
                  content={[
                    {
                      name: "Active Chains",
                      value: `${activeChains.length}`,
                      backgroundColor: "#EFEBFB",
                      color: "#6F32C9",
                    },
                    {
                      name: "Total number of Chains",
                      value: `${
                        props?.activeChainsVendor?.length +
                          props?.pendingChainsVendor?.length +
                          props?.onHoldChainsVendor?.length || 0
                      }`,
                      backgroundColor: "#D8F3F4",
                      color: "#138B90",
                    },
                  ]}
                />
              </div>
              <div className="row">
                <div className="col-4">
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="amSearch"
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../../assets/images/iconButton/sorticon.png")}
                        width="35px"
                        alt="icon"
                      />
                      <br />
                      Sort
                    </div>
                    <div
                      className="f10-400"
                      align="center"
                      onClick={() => handleShowFilter()}
                    >
                      <img
                        src={require("../../../../assets/images/iconButton/filtericon.png")}
                        width="35px"
                        alt="icon"
                      />
                      <br />
                      Filter
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../../assets/images/iconButton/downloadicon.png")}
                        width="35px"
                        alt="icon"
                      />
                      <br />
                      Download
                    </div>
                  </div>
                </div>
              </div>

              {/* <Row className="mt-2">
                <Col md={2} className="d-flex justify-content-between">
                  <div
                    className={`${!screen && `selected-tab`} f14-400 `}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setScreen(false);
                    }}
                  >
                    All
                  </div>
                  <div
                    className={`${screen && `selected-tab`} f14-400 `}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setScreen(true);
                    }}
                  >
                    On-Hold
                  </div>
                </Col>
              </Row> */}
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                <Table>
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <th style={{ width: "9%" }} className="f12-700">
                        Business <br />
                        ID
                      </th>
                      <th style={{ width: "13%" }} className="f12-700">
                        Business Chain <br /> Name
                      </th>
                      <th style={{ width: "13%" }} className="f12-700">
                        Chain <br />
                        Category
                      </th>
                      <th style={{ width: "15%" }} className="f12-700">
                        Address
                      </th>
                      <th style={{ width: "10%" }} className="f12-700">
                        City
                      </th>
                      <th style={{ width: "10%" }} className="f12-700">
                        Area/
                        <br />
                        Zip code
                      </th>

                      <th style={{ width: "10%" }} className="f12-700">
                        Business type/ <br />
                        Cuisine Offered
                      </th>
                      <th style={{ width: "20%" }} className="f12-700">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <ChainsListVendorActive
                    activeChains={activeChains.filter(
                      (e) =>
                        e?.title
                          ?.toString()
                          ?.toLowerCase()
                          ?.includes(search?.toString()?.toLowerCase()) ||
                        e?.address
                          ?.toString()
                          ?.toLowerCase()
                          ?.includes(search?.toString()?.toLowerCase()) ||
                        e?.city
                          ?.toString()
                          ?.toLowerCase()
                          ?.includes(search?.toString()?.toLowerCase()) ||
                        e?.area
                          ?.toString()
                          ?.toLowerCase()
                          ?.includes(search?.toString()?.toLowerCase()) ||
                        e?.zip_code
                          ?.toString()
                          ?.toLowerCase()
                          ?.includes(search?.toString()?.toLowerCase())
                    )}
                    updateStatus={updateStatus}
                    key={activeChains}
                    // handleShowView={handleShowView}
                    // handleShowView2={handleShowView2}
                  />
                </Table>
              </div>
              {activeChains.length > 0 && (
                <BasicPagination
                  totalRecords={activeChains.length}
                  limit={10}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
              )}
              {/* <ViewEventDetailsOffline
                handleCloseView={handleCloseView}
                showView={showView}
              />
              <ViewEventDetailsOnline
                onClickCloseView={handleCloseView2}
                onClickshowView={showView2}
              /> */}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

// export default SuperAdminActiveChainsVendor;

export default SuperAdminActiveChainsVendor;
